import React from "react";
import {t} from "../../../shared-services/translate";
import BottomDefaultNotification from "./Bottom.defaultNotification";

const BottomSaturdayDelivery = () => {
  const name = "BottomSaturdayDelivery";

  return <>
    <BottomDefaultNotification name={name}>
      <img
        alt="no saturday delivery"
        src="/resources/farmy/images/icons/quick_delivery_truck.svg"
        loading="lazy"
      />
      {t("products.no_delivery_on_saturday")}
    </BottomDefaultNotification>
  </>;
};

export default BottomSaturdayDelivery;
